import React, { ButtonHTMLAttributes } from "react";
import StyledButton from "./Button.styled";
import { IButton } from "./Button.interface";

const Button = (props: IButton): JSX.Element => <StyledButton {...props} />;

export default Button;
